module.exports = __webpack_public_path__ + "img/Finia.96f6841f.webp";